import { render, staticRenderFns } from "./AdditionalSurgeryCodesPrompt.vue?vue&type=template&id=1654fefa&scoped=true"
import script from "./AdditionalSurgeryCodesPrompt.vue?vue&type=script&lang=js"
export * from "./AdditionalSurgeryCodesPrompt.vue?vue&type=script&lang=js"
import style0 from "./AdditionalSurgeryCodesPrompt.vue?vue&type=style&index=0&id=1654fefa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654fefa",
  null
  
)

export default component.exports